import React from 'react';
import bgImage from '../../assets/products/hero2.png';
import card from '../../assets/products/card.png';
import card2 from '../../assets/products/card2.png';

const items = new Array(8).fill({
  image: card,
  title: 'Recorded Sessions',
  desc: 'Access to recorded classes for review and revision. Flexible viewing options for students with different schedules.',
  link: ''
});
const items2 = new Array(3).fill({
  image: card2,
  title: 'Encouraging Enrollment',
  desc: 'These mobile applications may also assist you in attracting global memberships in addition to your online job, which will ultimately help in the fundraising of funds for your non-profit organization.',
  link: ''
});

const NGO = () => {
  return (
    <div className="flex flex-col gap-[64px]">

      {/* Hero Section */}
      <div className='h-[40vh] md:h-[50vh] lg:h-screen w-full text-white flex justify-start items-center pt-24 relative bg-cover bg-center'

        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="absolute inset-0 bg-[rgba(89, 119, 221, 0.25)] z-0"></div>
        <div className="flex flex-col gap-[32px] sm:gap-[16px] p-10 sm:p-6 md:p-28 z-10">
  <div className="flex flex-col gap-[32px] sm:gap-[16px]">
    {/* Heading: Avinya NGO App */}
    <p className="font-poppins text-[25px] sm:text-[30px] md:text-[40px] lg:text-[50px] leading-[35px] sm:leading-[50px] md:leading-[70px] lg:leading-[80px] font-semibold text-left animate__animated animate__fadeIn animate__delay-1s">
      Avinya NGO App
    </p>
    
    {/* Subheading: The Ultimate Learning Hub for Students */}
    <p className="text-[16px] sm:text-[18px] md:text-[20px] lg:text-[30px] w-full sm:w-[100%] font-normal leading-[22px] sm:leading-[24px] md:leading-[40px] lg:leading-[50px] text-left animate__animated animate__fadeIn animate__delay-2s">
      The Ultimate Learning Hub for Students
    </p>
  </div>
</div>

      </div>

      {/* Features Section */}
      <p className="text-center font-poppins text-[28px] sm:text-[32px] md:text-[36px] lg:text-[40px] font-semibold leading-[32px] sm:leading-[36px] md:leading-[40px] lg:leading-[44px] animate__animated animate__fadeIn">
  Features of Avinya NGO App
</p>


      <div className="flex flex-wrap justify-center gap-[30px] animate__animated animate__fadeIn animate__delay-3s">
        {items.map((item, index) => (
          <div key={index} className="w-[292px] h-[447px] flex flex-col items-center bg-white gap-[8px] border-2 rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300">
            <img src={item.image} alt="card" className="rounded-tr-lg rounded-tl-lg" />
            <div className="h-[90%] flex flex-col items-center gap-[10px] px-6 py-4">
              <p className="text-[#3C4858] text-center font-poppins font-bold text-[20px] ">{item.title}</p>
              <p className="font-poppins text-[#161C2D] text-center text-[16px] leading-[24px]">{item.desc}</p>
            </div>
            <button className="bg-gradient-to-r from-[#006BD3] to-[#004BB5]  w-[240px] md:w-[260px] lg:w-[280px] h-[50px] rounded-lg text-white mb-5 transition-all duration-300 ease-in-out transform hover:scale-105 hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#004BB5]  text-lg sm:text-[14px] md:text-[18px]">
  View More
</button>


          </div>
        ))}
      </div>

      {/* Push Notifications Section */}
      <div className="flex flex-col gap-[32px] w-full">
  {/* Title: Push Notifications */}
  <p className="text-center font-poppins text-[24px] sm:text-[28px] md:text-[32px] lg:text-[36px] font-semibold leading-[28px] sm:leading-[32px] md:leading-[35px] lg:leading-[40px] animate__animated animate__fadeIn animate__delay-4s">
    Push Notifications
  </p>
  
  {/* Description: Push Notification Feature */}
  <p className="text-justify text-[14px] sm:text-[14px] md:text-[16px] lg:text-[18px] leading-[24px] sm:leading-[28px] md:leading-[30px] lg:leading-[32px] px-6 sm:px-12 md:px-32 lg:px-40 font-poppins animate__animated animate__fadeIn animate__delay-4.5s">
    Our NGO app features Push Notifications to keep stakeholders informed and engaged. This feature allows you to send real-time alerts and updates directly to users' devices, including news, event reminders, and important announcements. Push Notifications ensure timely communication and enhance engagement with your NGO’s activities and initiatives.
  </p>
</div>


      {/* Additional Features Section */}
      <div className="flex flex-wrap justify-center gap-[30px] mb-10 animate__animated animate__fadeIn animate__delay-5s">
        {items2.map((item, index) => (
          <div key={index} className="w-[350px] h-[441px] flex flex-col items-center bg-white gap-[8px] border-2 rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300">
            <img src={item.image} alt="card" className="rounded-tr-lg rounded-tl-lg" />
            <div className="h-[90%] flex flex-col items-center gap-[10px] px-6 py-4">
              <p className="text-[#3C4858] text-center font-poppins font-bold text-[20px] hover:text-blue-900">{item.title}</p>
              <p className="font-poppins text-[#161C2D] text-center text-[16px] leading-[24px]">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default NGO;


